/**
 * Crud
 * service
 * mantem funcionalidades
 * padrão de banco de dados
 *
 */

import { Injectable } from '@angular/core';
import { GenericHttpService } from './generic-http.service';
import {tap, delay} from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import {ExportTypes} from '../shared/enum/shared.enum';

/**
 * @Injectable()
 * CrudService
 * (ciclo angular)
 *
 */
@Injectable()

/**
 * export
 * CrudService
 * (ciclo angular)
 *
 */
export class CrudService {
  /**
   * constructor
   * CrudService
   * (ciclo angular)
   *
   */

  constructor(private readonly gHttp: GenericHttpService) {}

  // variavel para setar a rota _routePrefix
  _routePrefix: string;

  get routePrefix(): string {
    return this._routePrefix;
  }

  set routePrefix(value: string) {
    this._routePrefix = value;
  }

  /**
   * getAll busca todos os dados
   * @returns subscribe
   */
  getAll(api:string) {
    return  this.gHttp.get<any>(`${this.routePrefix}`, api);
  }

  getById(teste: any,api:string) {
    return  this.gHttp.get<any>(`${this.routePrefix}`,api);
  }

  getAllbyAsync(api:string) {
    return  this.gHttp.get<any>(`${this.routePrefix}`,api)
    .pipe(delay(2000),
     tap(console.log));
  }

    /**
   * getAll
   * busca todos os dados
   * por filtro
   * @param pDto
   * @returns subscribe
   */
  getAllPorFiltro(pFiltro: any,api:string) {
    return this.gHttp.post<any>(`${this.routePrefix}`, pFiltro, api);
  }

  /**
   * add
   * item no
   * banco de daodos
   * @param pDto
   * @returns subscribe
   */
  add(pDto: any,api:string) {
   return this.gHttp.post<any>(`${this.routePrefix}`, pDto, api);
  }

  importarArquivo(form: FormData,api:string)   {
    return this.gHttp.importarArquivo<any>(`${this.routePrefix}`,form,api);
  }

  /**
   * update
   * atualiza item
   * banco de dados
   *
   * @param pDto
   * @returns subscribe
   */
  update(pDto: any,api:string) {
    return this.gHttp.put<any>(`${this.routePrefix}`, pDto,api);
  }

  /**
   * delete
   * item do banco
   * @param pDto
   * @returns subscribe
   */
  delete(pId: any,api:string) {
    return this.gHttp.delete(`${this.routePrefix}/${pId}`,api);
  }

   /**
   * getItem busca item
   * @returns subscribe
   */
  getItem(routePrefixLocal: string, pId: string, api:string) {
    return this.gHttp.get<any>(`${routePrefixLocal}/${pId}`,api);
  }

  report(filtro: any, exportType: ExportTypes, api:string): Observable<Blob> { 
    return this.gHttp.report(`${this.routePrefix}`, filtro, exportType, api);

  }
}



// WEBPACK FOOTER //
// ./src/app/services/crud.service.ts